<template>
  <div class="jumbotron overflow-x-hidden">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      loading: 'pageLoading',
    }),
  },
};
</script>

<style lang="css">

#slider-area .vue-slider-component .vue-slider-process {
  background-color: #ee6f56;
}

@keyframes borderFlip {
  from {
    border-color: #E9494A;
  }

  to {
    border-color: #E67E22;
  }
}

@keyframes bgFlip {
  from {
    background-color: #E9494A;
  }

  to {
    background-color: #E67E22;
  }
}

@keyframes blinkingBlue {
  from {
    background-color: #ECF0F4;
  }

  to {
    background-color: #2C82C9;
  }
}

@keyframes borderBlinkingBlue {
  from {
    border-color: #ECF0F4;
  }

  to {
    border-color: #3490dc;
  }
}

/* The element to apply the animation to */
.bg-flipDanger {
  animation-name: bgFlip;
  animation-duration: .5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.border-flipDanger {
  animation-name: borderFlip;
  animation-duration: .5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.bg-blinkingBlue {
  animation-name: blinkingBlue;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.border-blinkingBlue {
  animation-name: borderBlinkingBlue;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.date-title {
  margin-bottom: 10px;
}

.date-title p {
  background-color: rgba(225, 245, 254, 0.92);
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  padding: 6px 12px;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
}

.unread-messages-title {
  margin-top: 10px;
}

.unread-messages-title p {
  background-color: #e9494a;
  border-radius: 25px;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.13);
  padding: 6px 50px;
  color: white;
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(233, 73, 74, 0.4);
  font-size: .75em;
}

</style>
